<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">
    Table of Contents
  </div>
<div class="sgc-toc-level">
<a href="#/Text/PartOne">PART I</a>
<div class="sgc-toc-level1">
<a href="#/Text/PartOne#toc-anchor-5">Every Parent’s Nightmare</a>
<div class="sgc-toc-level1">
<a href="#/Text/Chapter_001">CHAPTER ONE</a>
</div>
<div class="sgc-toc-level1">
<a href="#/Text/Chapter_002">CHAPTER TWO</a>
</div>
<div class="sgc-toc-level1">
<a href="#/Text/Chapter_003">CHAPTER THREE</a>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_004" title="Link target outside of Sample">CHAPTER FOUR</span>
</div>
</div>
</div>
<div class="sgc-toc-level">
<span href="#/Text/PartTwo" title="Link target outside of Sample">PART II</span>
<div class="sgc-toc-level1">
<span href="#/Text/PartTwo#toc-anchor-8" title="Link target outside of Sample">A Case of Divine Intervention</span>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_005" title="Link target outside of Sample">CHAPTER FIVE</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_006" title="Link target outside of Sample">CHAPTER SIX</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_007" title="Link target outside of Sample">CHAPTER SEVEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_008" title="Link target outside of Sample">CHAPTER EIGHT</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_009" title="Link target outside of Sample">CHAPTER NINE</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_010" title="Link target outside of Sample">CHAPTER TEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_011" title="Link target outside of Sample">CHAPTER ELEVEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_012" title="Link target outside of Sample">CHAPTER TWELVE</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_013" title="Link target outside of Sample">CHAPTER THIRTEEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_014" title="Link target outside of Sample">CHAPTER FOURTEEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_015" title="Link target outside of Sample">CHAPTER FIFTEEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_016" title="Link target outside of Sample">CHAPTER SIXTEEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_017" title="Link target outside of Sample">CHAPTER SEVENTEEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_018" title="Link target outside of Sample">CHAPTER EIGHTEEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_019" title="Link target outside of Sample">CHAPTER NINETEEN</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_020" title="Link target outside of Sample">CHAPTER TWENTY</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_021" title="Link target outside of Sample">CHAPTER TWENTY-ONE</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_022" title="Link target outside of Sample">CHAPTER TWENTY-TWO</span>
</div>
</div>
</div>
<div class="sgc-toc-level">
<span href="#/Text/PartThree" title="Link target outside of Sample">PART III</span>
<div class="sgc-toc-level1">
<span href="#/Text/PartThree#toc-anchor-11" title="Link target outside of Sample">Prayers Have Been Answered</span>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_023" title="Link target outside of Sample">CHAPTER TWENTY-THREE</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Chapter_024" title="Link target outside of Sample">CHAPTER TWENTY-FOUR</span>
</div>
<div class="sgc-toc-level1">
<span href="#/Text/Epilogue" title="Link target outside of Sample">EPILOGUE</span>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?30ff28d2